// GA4 送信のための型定義（dataLayer は GTM スニペットがグローバルに注入する）
declare global {
  interface Window {
    dataLayer: {
      push: ({ user_id, event }: { user_id: string; event: string }) => void;
    };
  }
}

export const insertToGA4DataLayer = (username: string) => {
  window.dataLayer.push({
    user_id: username,
    event: "updateUserId",
  });
};
